import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconPortal(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M16 8a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM15 12a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM16 14a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21 4H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 6a2 2 0 0 0-2-2ZM3 18V6h18v12H3Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M11 10c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2ZM11.78 13.58A2.01 2.01 0 0 1 13 15.43V16H5v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0Z"
      />
    </BaseIcon>
  );
}
